import type { TickBundle } from '@archon3d/core';

/**
 * The server's tick bundles, handed out strictly in order. Bundles may arrive out of order or
 * twice (a resume replays the duel so far); anything already applied is dropped.
 */
export class TickBuffer {
  private readonly bundles = new Map<number, TickBundle>();
  private next = 0;

  /** The tick the next `take` returns. */
  get nextTick(): number {
    return this.next;
  }

  /** How many bundles can be taken right now without a gap. */
  get available(): number {
    let n = 0;
    while (this.bundles.has(this.next + n)) n += 1;
    return n;
  }

  push(bundle: TickBundle): void {
    if (bundle.tick >= this.next) this.bundles.set(bundle.tick, bundle);
  }

  take(): TickBundle | undefined {
    const bundle = this.bundles.get(this.next);
    if (!bundle) return undefined;
    this.bundles.delete(this.next);
    this.next += 1;
    return bundle;
  }
}
